interface PreviewProps {
  html: string;
  isLoading: boolean;
}

export default function Preview({ html, isLoading }: PreviewProps) {
  return (
    <div className="w-full h-full flex flex-col bg-gray-50 dark:bg-gray-900">
      <div className="h-10 border-b border-gray-200 dark:border-gray-700 flex items-center px-4 bg-gray-50 dark:bg-gray-900">
        <span className="text-sm font-medium text-gray-600 dark:text-gray-400">
          Preview
        </span>
      </div>
      <div className="flex-1 overflow-auto custom-scrollbar preview-container">
        {isLoading ? (
          <div className="flex items-center justify-center h-full">
            <div className="w-8 h-8 border-4 border-blue-500 border-t-transparent rounded-full animate-spin" />
          </div>
        ) : (
          <div dangerouslySetInnerHTML={{ __html: html }} />
        )}
      </div>
    </div>
  );
}
